export const carerTrackingBottomFeatures = [
    {
        id: '1',
        title: 'Simple To Use',
        content: 'Tracking works in the background with no complicated setup or maintenance. Perfect for people who are less comfortable with technology.',
        imgName: 'earth'
    },
    {
        id: '2',
        title: 'Immediate Emergency Awareness',
        content: "If something happens, you’ll know instantly with emergency alerts.",
        imgName: 'checkCircleIcon'
    },
    {
        id: '3',
        title: 'Reduces the Need for Constant Check-Ins',
        content: "You can check their status without interrupting their day.",
        imgName: 'mobilePhoneIcon'
    },
    {
        id: '4',
        title: 'Non-Intrusive, Respectful Monitoring',
        content: "Helps maintain their independence and dignity while giving you peace of mind.",
        imgName: 'eye'
    },
];